<template>
    <b-td v-bind="$props">
        <slot />
    </b-td>
</template>

<script>
import { BTd } from 'bootstrap-vue'

export default {
    components: { BTd },
    props: {
        colspan: { type: [Number, String], default: null },
        rowspan: { type: [Number, String], default: null },
        stackedHeading: { type: String },
        stickyColumn: { type: Boolean, default: false },
    }
}
</script>